import { plural, t } from "../../i18n";
import { MAX_UPLOAD_BYTES } from "../../lib/validators";

export const buildDefaultSubject = (patientName?: string) =>
  patientName ? t("sharing.email.defaultSubjectWithPatient", { patient: patientName }) : t("sharing.email.defaultSubject");

export function buildDefaultBody(doctorName?: string, patientName?: string, reservaNames: string[] = []): string {
  const lines = [
    t("sharing.email.bodyGreeting"),
    "",
    patientName ? t("sharing.email.bodyAttachedWithPatient", { patient: patientName }) : t("sharing.email.bodyAttached"),
  ];
  if (reservaNames.length > 0) lines.push("", t("sharing.email.bodyReservas"), ...reservaNames.map((name) => `- ${name}`));
  lines.push("", t("sharing.email.bodyClosing"), "", t("sharing.email.bodySignature"), doctorName ?? "");
  return lines.join("\n");
}

export const isPdf = (file: File) => file.type === "application/pdf" || file.name.toLowerCase().endsWith(".pdf");

/** Separa os PDFs aceitos dos avisos (não-PDF, acima de 10 MB); ignora os já anexados. */
export function acceptPdfs(chosen: File[], current: File[]): { accepted: File[]; warnings: string[] } {
  const pdfs = chosen.filter(isPdf);
  const tooBig = pdfs.filter((f) => f.size > MAX_UPLOAD_BYTES);
  const known = new Set(current.map((f) => `${f.name}-${f.size}`));
  const accepted = pdfs.filter((f) => f.size <= MAX_UPLOAD_BYTES &&!known.has(`${f.name}-${f.size}`));

  const warnings: string[] = [];
  const notPdf = chosen.length - pdfs.length;
  if (notPdf > 0) warnings.push(plural(notPdf, { one: t("sharing.email.notPdf.one"), other: t("sharing.email.notPdf.other") }));
  if (tooBig.length > 0) warnings.push(t("sharing.email.tooBig", { name: tooBig[0].name }));
  return { accepted, warnings };
}

export function formatFileSize(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(0)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}
